import { render, staticRenderFns } from "./CustomerInfoSetting.vue?vue&type=template&id=7f2b9f29&scoped=true&"
import script from "./CustomerInfoSetting.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoSetting.vue?vue&type=style&index=0&id=7f2b9f29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b9f29",
  null
  
)

export default component.exports